<!-- 新增站点 -->
<template>
    <div class="layout-container">
        <div class="form-group-style addSite-form">
            <template>
                <el-form
                        class="form-container"
                        :model="info"
                        :rules="infoRules"
                        ref="userInfoForm"
                        label-width="80px"
                        style="margin-bottom:30px;"
                >
                    <h6 class="title">基本信息</h6>
                    <el-row :gutter="40">
                        <el-col :span="16">
                            <div class="form-item">
                                <div class="form-label">
                                    <span class="label">城市</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item label="" prop="city_id" >
                                        <DynamicSelect :list="list" :callback="selectCallback" ref="dynamicCityRef" />
                                        <el-input style="display: none" placeholder="请输入站点名称" class="input-control" v-model="info.city_id"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label">
                                    <template>
                                        <el-checkbox v-model="info.is_hot_checked">热门站点</el-checkbox>
                                    </template>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="40">
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label">
                                    <span class="label">站点名称</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item prop="name">
                                        <el-input placeholder="请输入站点名称" class="input-control" v-model="info.name"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label">
                                    <span class="label">站点拼音</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item prop="pinyin">
                                        <el-input v-model="info.pinyin" placeholder="请输入拼音字母">
                                            <div slot="append" @click="getPinyin()">获取</div>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label">
                                    <span class="label">域名</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item prop="domain_pinyin">
                                        <el-input v-model="info.domain_pinyin" placeholder="请输入域名">
                                            <div slot="append" @click="getRepeat()">查重</div>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="40">
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label" width="150px;!important">
                                    <span class="label">百度地铁城市id</span>
                                    <label class="warn">*</label>
                                </div>

                                <div class="form-input-item">
                                    <el-form-item prop="baidu_city_code">
                                        <el-input v-model="info.baidu_city_code" placeholder="百度地铁城市数字id，没有请填0"></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="form-item">
                                <div class="form-label">
                                    <span class="label">地图标注</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item prop="map_lng_map_lat">
                                    <el-input
                                        v-model="info.map_lng_map_lat"
                                        disabled
                                        placeholder="请点击获取经纬度"
                                    >
                                        <div slot="append" @click.stop.prevent="openGetLocation">
                                        获取
                                        </div>
                                    </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </template>

            <template>
                <!--
                <div class="form-container">
                    <h6 class="title">代理商信息</h6>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">平台代理商</span>
                        </div>
                    </div>
                </div>
                -->
                <div class="form-container" ref="factorInfoForm">
                    <h6 class="title">站点400号码</h6>
                    <div class="clearfix" style="margin-bottom: 5px">
                        <el-button
                                class="floatR"
                                icon="el-icon-plus"
                                @click.prevent.stop="openAddHotline"
                        >400号码</el-button>
                    </div>
                    <el-table
                            :data="hotlineList"
                            stripe
                            ref="multipleTable"
                            style="width: 100%"
                            :highlight-current-row="true"
                            tooltip-effect="dark"
                            header-cell-class-name="table-back"
                    >
                        <el-table-column label="已绑定400号码" prop="hotline_number"></el-table-column>
                        <el-table-column label="号码类型" prop="type_text"></el-table-column>
                        <el-table-column label="月最低消费" prop="minimum_charge_yuan"></el-table-column>
                        <el-table-column label="分机号位数" prop="telephone_length"></el-table-column>
                        <el-table-column fixed="right">
                            <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                            <template slot="header" slot-scope="scope">
                                <span style="color: #409EFF">操作</span>
                            </template>
                            <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                            <template slot-scope="scope">
                                <el-button size="mini" @click="handleRescission(scope.$index, scope.row)">解绑</el-button>
                                <el-button size="mini" @click="openEditHotline(scope.$index,scope.row)">编辑</el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="form-container" v-if="siteNavShow">
                    <h6 class="title">站点导航显示</h6>
                    <div class="fixed-data">
                        <span>二手房，小区及租房：</span>
                        <el-radio-group v-model="info.menu_extend" size="mini">
                        <el-radio :label="1">打开</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="form-container">
                    <h6 class="title">表单短信校验配置</h6>
                    <div class="fixed-data">
                        <span style="margin-right:20px">表单短信校验开关</span>
                        <el-radio-group v-model="info.form_sms_check" size="mini">
                            <el-radio :label="1">打开</el-radio>
                            <el-radio :label="0">关闭</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <h6 class="title">其他设置</h6>
                <div class="site-statics">
                    <label>百度竞价OCPC-TOKEN:</label>
                      <el-input
                        placeholder="百度竞价OCPC-TOKEN"
                        class="input-control"
                        v-model="info.baidu_ocpc_token"
                    ></el-input>
                 
                </div>
                <div class="site-statics">
                    <label>PC端百度商桥：</label>
                      <el-input
                        type="textarea"
                        placeholder="PC端百度商桥"
                        class="input-control"
                        v-model="info.pc_baidu_bridge_code"
                    ></el-input>
                 
                </div>
                 <div class="site-statics">
                    <label>M端百度商桥：</label>
                      <el-input
                        type="textarea"
                        placeholder="M端百度商桥"
                        class="input-control"
                        v-model="info.m_baidu_bridge_code"
                    ></el-input>
                 
                </div>
            </template>
            <template>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">保 存</el-button>
                    <el-button type="info" plain @click="backToList()">取 消</el-button>
                </div>
            </template>
            <bindHotline ref="bindHotline"/>
            <editHotline ref="editHotline"  :callback="editCallback" />
            <MapLocation :callback="getLocationCallback" ref="locationRef" />

        </div>
    </div>
</template>
<script>
    import bindHotline from "./bindHotline"
    import editHotline from "./editHotline";
    import MapLocation from "./map";
    import {validateEmpty, validateChat, validateNumber,validateNumberSite} from '@/utils/validate'
    import { getCities,createSite,bindCustomerHotlines,getRepeat,getPinyin } from '@/service/site'
    import DynamicSelect from '@/components/dynamicSelect'
    import {CunstomerHotlinesrescission} from "../../../../service/hotline";
    export default {
        name: 'add',
        components: {
            bindHotline,
            DynamicSelect,
            editHotline,
            MapLocation
        },
        data () {
            return {
                info: {
                    city_id: '',
                    name: '',
                    pinyin: '',
                    domain_pinyin: '',
                    baidu_city_code: 0,
                    is_hot_checked: false,
                    m_baidu_bridge_code:'',
                    pc_baidu_bridge_code:'',
                    map_lng_map_lat:'',
                    baidu_ocpc_token:'',
                    menu_extend:"0",
                    form_sms_check:1,
                },
                infoRules: {
                    city_id: [
                        { required: true, message: '请选择城市', trigger: 'blur' },
                    ],
                    name: [
                        { validator: validateEmpty, result: '站点名称', trigger: 'blur' },
                        { validator: validateChat, type:1,result: '站点名称',max:15}
                    ],
                    pinyin: [
                        { validator: validateEmpty, result: '站点拼音', trigger: 'blur' },
                        { validator: validateChat, type:2,result: '站点拼音'}
                    ],
                    domain_pinyin: [
                        { validator: validateEmpty, result: '域名', trigger: 'blur' },
                        { validator: validateChat, type:2,result: '域名'}
                    ],
                    baidu_city_code: [
                        {required: true, message: '百度地铁城市数字id，没有请填0', trigger: 'blur' },
                        { validator: validateNumberSite, type:3,min: 0, max: 999999999, result: '百度地铁城市数字id' }
                    ],
                    map_lng_map_lat: [
                        { required: true, message: "请输入地图标注", trigger: "change" }
                    ],
                },
                hotlineList: [],
                list: [
                    { key: '1', placeholder: '请选择省/自治区名称' },
                    { key: '2', placeholder: '请选择城市名称' },
                    { key: '3', placeholder: '请选择区县名称' },
                    { key: '4', placeholder: '请选择版块名称' },
                ],
                relList : {},
                siteNavShow:false,//淘房网站点可配置”二手房、租房、小区“导航入口
            }
        },
        mounted () {
            let domain=document.domain
            let host = window.serverConfig[window.siteMap[domain]].HOST;
            if(host=='taofang.com'){
                this.siteNavShow = true
            }
        },
        methods: {
            getLocationCallback (longitude, latitude) {
                this.$set(this.info, "map_lng_map_lat", longitude + "   " + latitude);
                this.$set(this.info, "map_lng", longitude);
                this.$set(this.info, "map_lat", latitude);
                this.$forceUpdate();
            },
            openGetLocation () {
                this.$refs.locationRef && this.$refs.locationRef.openDialog(this.info.map_lng, this.info.map_lat,'','');
            },
            backToList(){
                this.$router.push('list')
            },
            getPinyin() {
                if (this.info.name.length == 0) {
                    this.$message({
                        message: '站点名不能为空',
                        type: 'error',
                        duration: 3 * 1000
                    });
                    return false;
                }
                let query = {
                    name : this.info.name
                };
                getPinyin(query).then((data) => {
                    this.info.pinyin = data
                })
            },
            getRepeat() {
                if (this.info.domain_pinyin.length == 0) {
                    this.$message({
                        message: '域名不能为空',
                        type: 'error',
                        duration: 3 * 1000
                    });
                    return false;
                }
                let query = {
                    domain_pinyin : this.info.domain_pinyin,
                };
                getRepeat(query).then((data) => {
                    if (data.status == '0') {
                        this.$message({
                            message: '该域名可使用',
                            type: 'success',
                            duration: 3 * 1000
                        })
                    } else {
                        this.$message({
                            message: '该域名重复，请重新输入域名',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    }
                })
            },
            async selectCallback(id, type) {
                id = id ? id : 0;
                let query = {
                    up_id : id,
                    level : type,
                };
                this.info.city_id = id;
                return getCities(query).then((data) => {
                    return new Promise(resolve => {
                        let rel = [];
                        for (let i in data) {
                            let row = data[i];
                            this.relList[row.id] = row;
                            rel.push({
                                id : row.id,
                                name : row.name,
                            })
                        }
                        resolve(rel)
                    })
                })
            },

            openAddHotline () {
                let data = {
                    site_id: 0
                };
                this.$refs.bindHotline &&
                Object.assign(this.$refs.bindHotline.hotlineInfo, data) &&
                this.$refs.bindHotline.open();
            },
            openEditHotline(index,row){
                const result = Object.assign({}, {}, row)
                this.$refs.editHotline && this.$refs.editHotline.open(result,index)
            },
            editCallback(list,index){
                this.$set(this.hotlineList, index, list)
               
            },
            appendHotline (pamams) {
                if (pamams.type == 1) {
                    pamams.type_text = '独立大号'
                }else{
                    pamams.type_text = '公共大号'
                }
                if (pamams.only_user_400 == 1) {
                  pamams.hotline_number += '（直拔号）';
                }
                this.hotlineList.push(pamams)
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.relList[this.info.city_id].has_site == 1) {
                            this.$message({
                                message: '当前城市已经添加站点',
                                type: 'error',
                                duration: 3 * 1000
                            });
                            return false
                        }
                        let query = this.info;
                        query.is_hot = this.info.is_hot_checked == true ? 1 : 2; // 热门站点
                        query.operator_id = this.$store.state.user.userInfo.id;
                        query.operator = this.$store.state.user.userInfo.name;
                        // 获取最后一集选中数据
                        const areaId = this.$refs.dynamicCityRef && this.$refs.dynamicCityRef.getEndData();
                        if (areaId !== '') {
                            query['city_id'] = areaId
                        }
                        createSite(query).then((data) => {
                            this.$message({
                                message: '站点创建成功',
                                type: 'success',
                                duration: 3 * 1000
                            });
                            if (this.hotlineList.length > 0) {
                                query.hotline = this.hotlineList;
                                query.customer_id = data.customer_id;
                                query.factor_id = data.factor_id;
                                bindCustomerHotlines(query).then((data) => {
                                    this.$message({
                                        message: '绑定400号码成功',
                                        type: 'success',
                                        duration: 3 * 1000
                                    });
                                    this.$router.push('list')
                                }).catch(err => {
                                    this.$message({
                                        message: err.message || '绑定400号码失败',
                                        type: 'error',
                                        duration: 3 * 1000
                                    })
                                })
                            } else {
                                this.$router.push('list')
                            }
                        }).catch(err => {
                            this.$message({
                                message: err.message || '添加失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {
                        return false
                    }
                })
            },
            // 解绑-取消分配
            handleRescission(i, row) {
                this.$confirm('取消分配后将解除该400号码与站点以及分机号所有的绑定关系，不可恢复，是否确认操作？', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    this.hotlineList.splice(i, 1);
                }).catch((e) => {
                });
            },
        }
    }
</script>
<style  lang="less">
.addSite-form{
    padding: 20px;
    background-color: #fff;
    border-top:1px solid #ddd;
}
    .title{
        margin-top: 0px !important;
        font-size: 18px !important;
        color: #1a1a1a !important;
        padding: 5px 20px 0px !important;
        font-weight: normal !important;
    }
    .addSite-form .form-container .form-item .form-label {
        width: 80px !important;
        text-align: left!important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
    .addSite-form .form-container .form-input-item {
        width: 80% !important;
    }
    .form-container .fixed-data {
        padding: 20px 0;
    }
    .form-container .fixed-data p,
    .form-container .fixed-data span {
        color: #333;
        font-size: 14px;
        line-height: 36px;
    }
    .form-container .fixed-data p label {
        width: 100px !important;
        text-align: left;
        display: inline-block;
    }
    // .layout-container{
    //     padding:20px;
    //     background: #FFF;
    //     border: 1px solid #DCDFE6;
    //     box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    // }
    .addSite-form h6.title{
        padding:0!important;
        font-size:16px!important;
    }
    .site-statics{
        margin-top:30px;
    }
    .site-statics{
        display: flex;
    }
    .site-statics label{
        display: inline-block;
        font-size: 14px;
        width:180px;
        line-height: 36px;
    }

</style>